import React from 'react';
import Home from '../../Common/Home/Home';
import AddPPOConfiguration from './AddPPOConfiguration';

const AddPPOConfigurationWrapper = () => {
  return (
    <Home propComponent={<AddPPOConfiguration />}>
      <div style={{ padding: '20px' }}>
        <AddPPOConfiguration />
      </div>
    </Home>
  );
};

export default AddPPOConfigurationWrapper;
